/* 
    This mixin contains boilerplate for retaining an internal value,
    and granting v-model functionality for custom inputs
*/

import Vue from 'vue';

const mixVModel = Vue.extend({
    props:{
        value: [
            Object,
            Array,
            String,
            Number
        ]
    },
    data() {
        return {
            $_resetTimer: null,
            internalValue: this.value,
        };
    },
    computed: {
        computedValue:{
            get(){
                return this.internalValue;
            },
            set(value){
                this.$emit('input',value);
                this.internalValue = value;
            }
        },
    },
    watch:{
        value(){
            this.internalValue = this.value;
        },

    },

    methods: {}
});

export {mixVModel};
